import { writable } from "svelte/store";

export const user_info = writable({});
